import { WorkWithUsSection } from '@components/sections/WorkWithUsSection'
import DevOpsCloudHexagon from '@public/images/devops-cloud-hexagon.svg'

import { config } from './config'

export function TakeYourBusinessSection() {
  return (
    <WorkWithUsSection {...config}>
      <DevOpsCloudHexagon />
    </WorkWithUsSection>
  )
}
